import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SideMenuService, MessagesMenuService, NotificationsMenuService } from './core';
import { UserService } from './services/usuario.service';
import { NotifierService } from './shared/notifier/notifier.service';

//import { PublicMenuService } from './menu/public-menu.service';

@Component({
  selector: 'app-system',
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss'],
  providers: [UserService]
})
export class SystemComponent implements AfterViewInit {
  @ViewChild('drawerContainer') drawerContainer;
  @ViewChild('sideMenu') sideMenu;
  @ViewChild('sideNotifications') sideNotifications;

  notifications = [];
  messages = [];
  userManagemet: any;
  constructor(
    private router: Router,
    private sideMenuService: SideMenuService,
    private messagesMenuService: MessagesMenuService,
    private notificationsMenuService: NotificationsMenuService,
    private userService: UserService,
    private notifierService: NotifierService,
  ) {
    notificationsMenuService.getNotifications().then((notifications: any) => {
      this.notifications = notifications;
    });
    messagesMenuService.getMessages().then((messages: any) => {
      this.messages = messages;
    })
    this.userService.obtenerDatosPersonales().subscribe((result) => {
      this.notifierService.userMgmtNotify(result);
      this.userManagemet = result;
    })
  }

  ngAfterViewInit(): void {
    this.sideMenuService.sidenav = this.sideMenu;
    this.sideMenuService.drawerContainer = this.drawerContainer;
    this.notificationsMenuService.sidenav = this.sideNotifications;
  }

}


// WEBPACK FOOTER //
// ./src/app/system/system.component.ts